import { render, staticRenderFns } from "./NewSoftwareForm.vue?vue&type=template&id=8c477072"
import script from "./NewSoftwareForm.vue?vue&type=script&lang=js"
export * from "./NewSoftwareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports